import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AddIcon from '@mui/icons-material/Add';
import PublishIcon from '@mui/icons-material/Publish';
import CheckIcon from '@mui/icons-material/Check';

export const navigationMap = {
  add: <AddIcon />,
  check: <CheckIcon />,
  formatListBulleted: <FormatListBulletedIcon />,
  publish: <PublishIcon />,
};
